import * as actionTypes from "../actions/WorkspaceAdminActions";

const initialState = {
  Loading: false,
  llmList: [],
  llmPrompts: [],
  modelVoices:[],
  verifyConfig:[],
  workspaceAdminList: [],
  workspaceAdminListForChat: [],
  getUser :[],
  workspaceAdminRecord: [],
  workspaceAdminDropdownList: [],
  workspaceAdminAttachmentList: [],
  validation_error: "",
  attachment_validation_error: "",
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
  closeModal:false,
  session: null, // Add session state
};
const WorkspaceAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.WORKSPACE_ADMIN_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };
  
    case actionTypes.ADMIN_USER_ACCESS:
      return {
        getUser:action.getUser,
      }  
    case actionTypes.WORKSPACE_ADMIN_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        workspaceAdminList: action.workspaceAdminList,
        showUpdateForm: false,
        showViewPage: false,
        workspaceAdminRecord: [],
      };
   
    case actionTypes.WORKSPACE_ADMIN_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        workspaceAdminRecord: [],
      };
    case actionTypes.WORKSPACE_ADMIN_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        workspaceAdminRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.WORKSPACE_ADMIN_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        workspaceAdminDropdownList: action.workspaceAdminDropdownList,
      };
    case actionTypes.WORKSPACE_ADMIN_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_WORKSPACE_ADMIN_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.REDIRECT_TO_WORKSPACE_ADMIN_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        workspaceAdminRecord: [],
      };

    //workspace attachments
    case actionTypes.WORKSPACE_ADMIN_ATTACHMENT_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        attachment_validation_error: action.attachment_validation_error,
      };
    case actionTypes.WORKSPACE_ADMIN_ATTACHMENT_SUCCESS:
      return {
        ...state,
        Loading: false,
        attachment_validation_error: "",
        workspaceAdminAttachmentList: action.workspaceAdminAttachmentList,
      };

    case actionTypes.WORKSPACE_ADMIN_CHAT_GET_LLM_PROMPTS_SUCCESS:
      return {
        ...state,
        Loading: false,
        llmPrompts: action.llmPrompts,
      };

    case actionTypes.WORKSPACE_ADMIN_CHAT_GET_LLM_MODEL_SUCCESS:
      return {
        ...state,
        Loading: false,
        llmList: action.llmList,
      };

      case actionTypes.WORKSPACE_ADMIN_CHAT_GET_MODELS_VOICES_SUCCESS:
        return {
          ...state,
          Loading: false,
          modelVoices: action.modelVoices,
        };
    // case actionTypes.CHAT_GET_PERSONA_SUCCESS:
    //     return {
    //       ...state,
    //       Loading: false,
    //       verifyPersona: action.verifyPersona,
    //   };
    // case actionTypes.CHAT_GET_INSTRUCTIONS_SUCCESS:
    //     return {
    //       ...state,
    //       Loading: false,
    //       verifyInstructions: action.verifyInstructions,
    //   };  

    default:
      return state;

   
  }
};

export default WorkspaceAdminReducer;
